import React, { useState } from "react";
import { Typography, Box } from "@mui/material";
import DynamicEditor from "./DynamicEditor";

interface ViewItem {
  item_id: string;
  parent_item_id?: string | null;
  data_index?: string;
  label_text?: string;
  renderer?: string;
  width?: number | null;
  pinned?: number | null;
  seq_no?: number;
  role?: string;
  extra_props?: Record<string, any>;
  _isNew?: boolean;
  [key: string]: any;
}

interface DynamicFormProps {
  viewRows: ViewItem[];
  rootProps?: Record<string, any>;
  viewType?: string;
  isTopDown?: boolean;
  allowTDOnly?: boolean;
  onDirtyChange?: (newData: ViewItem[], newTdMap: Record<string, boolean>) => void;
  onDataChange?: (newData: ViewItem[]) => void;
  onRootChange?: (rootProps: Record<string, any>) => void;
  itemCatalog?: Record<string, any>;
  itemCatalogKeys?: string[];
  readOnly?: boolean;
}

function DynamicForm({
  viewRows,
  rootProps = {},
  viewType = "",
  isTopDown,
  allowTDOnly = false,
  onDirtyChange,
  onDataChange,
  onRootChange,
  itemCatalog,
  itemCatalogKeys,
  readOnly = false
}: DynamicFormProps) {

const [tdOnlyMap, setTdOnlyMap] = useState<Record<string, boolean>>({});

const handleDirtyChange = (newData: ViewItem[], newTdMap: Record<string, boolean>) => {
  setTdOnlyMap(newTdMap);
  if (onDirtyChange) {
    onDirtyChange(newData, newTdMap);
    onDataChange?.(newData);
  }
};

 const nestedRows =
   Array.isArray(viewRows) && viewRows.length > 0
     ? viewRows
   : [];  // Don't fall back to rootProps.view - keep empty to avoid missing item_id error

  // Check if rootProps has view data that can't be displayed
  const hasRootPropsViewData =
    (Array.isArray(rootProps.main?.view) && rootProps.main.view.length > 0) ||
    (Array.isArray(rootProps.columns) && rootProps.columns.length > 0) ||
    (Array.isArray(rootProps.view) && rootProps.view.length > 0);

    return (
        <Box sx={{ p: 2 }}>
          {/* 1️⃣ Live Table Editor */}
          <Typography variant="h6" gutterBottom>
            Configuration Editor
          </Typography>

          <DynamicEditor
            data={nestedRows}
            rootProps={rootProps}
            onDataChange={onDataChange}
            onRootChange={onRootChange}
            isTopDown={isTopDown}
            tdOnlyMap={tdOnlyMap}
            setTdOnlyMap={setTdOnlyMap}
            onDirtyChange={handleDirtyChange}
            allowTdOnly={allowTDOnly}
            itemCatalog={itemCatalog}
            itemCatalogKeys={itemCatalogKeys}
            readOnly={readOnly}
          />

        </Box>
      );
     }

export default DynamicForm;
